import React, { type FC } from 'react';

export const RebrandedAlertSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path d="M11.2526 6.66927V4.16927H8.7526V6.66927L9.16927 12.5026H10.8359L11.2526 6.66927Z" />
            <path d="M11.2526 14.5859C11.2526 15.2763 10.693 15.8359 10.0026 15.8359C9.31225 15.8359 8.7526 15.2763 8.7526 14.5859C8.7526 13.8956 9.31225 13.3359 10.0026 13.3359C10.693 13.3359 11.2526 13.8956 11.2526 14.5859Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.1693 10.0026C19.1693 15.0652 15.0652 19.1693 10.0026 19.1693C4.93999 19.1693 0.835938 15.0652 0.835938 10.0026C0.835938 4.93999 4.93999 0.835938 10.0026 0.835938C15.0652 0.835938 19.1693 4.93999 19.1693 10.0026ZM17.5026 10.0026C17.5026 14.1447 14.1447 17.5026 10.0026 17.5026C5.86047 17.5026 2.5026 14.1447 2.5026 10.0026C2.5026 5.86047 5.86047 2.5026 10.0026 2.5026C14.1447 2.5026 17.5026 5.86047 17.5026 10.0026Z"
            />
        </svg>
    );
};
